export const LocalTime = (time: string | undefined): string => {
    if (!time) {
        return "";
    }
    const localTime = new Date(time).toLocaleTimeString();
    const localDate = new Date(time).toLocaleDateString();
    return "Local Time: " + localDate + " " + localTime;
}